import noUiSlider from 'nouislider';
import { ContentItemTypes } from 'modules/Boards/Types';
import AddToMyBoards from '../components/addToMyBoards';
import LoginRedirect from '../critical/loginRedirection';
import * as GoogleTagManager from '../modules/GoogleTagManager';
import '../components/customPatternModal';
import { delay as _delay } from 'lodash';

import {
  createElement,
  query,
} from '../modules';
import {
  utility,
} from '../modules/utility';

const filtersContainer = document.getElementById('active-filters-container');
const productsContainer = document.getElementById('products-container');
const suggestionsContainer = document.getElementById('suggestions-container');
const searchBar = document.getElementById('search-bar');
const searchBarForm = document.getElementById('search-bar-form');
const sortDropdownElement = document.getElementById('sort-by-select');
const tilesEndpoint = document.getElementById('product-tile-endpoint').value;
const suggestionEndpoint = document.getElementById('suggestion-endpoint').value;
const measurementSystemsEndpoint = document.getElementById('measurement-systems-endpoint').value;

const collectionEndpoint = document.getElementById('collection-details-endpoint').value;
const loadingSpinner = document.getElementById('products-spinner');
const filtersCollapseBtn = document.getElementById('filters-collapse-btn');
const inStockSwitch = document.getElementById('inStockSwitch');
const mdlCheckbox = document.getElementById('in-stock-merge');
const measurementSystemSwitch = document.getElementById('measurement-system-switch');

const {
  i18n,
  FormatText,
  CustomPatternModal,
} = ShawContract;

const QUERY_SEARCH_BAR_KEY = 'searchText';
const QUERY_SEARCH_BAR_KEY_ALT = 'searchTerm';
const QUERY_SORT_KEY = 'sortby';
const DEFAULT_SORT_TYPE = 'date desc';
const FACE_WEIGHT_START = 'faceWeightStart';
const FACE_WEIGHT_END = 'faceWeightEnd';
const IN_STOCK = 'InStock';
const MDL = 'MDL';
const DISPLAY_SIZE = 'DisplaySize';

if ('scrollRestoration' in history) {
  history.scrollRestoration = 'manual';
}

const navigatedBackFromProduct = window.sessionStorage.getItem('navigatedBackFromProduct')
if (navigatedBackFromProduct != window.location?.href) {
  clearCachedProducts()
}

const Page = {
  state: {
    filters: {},
    activeFilters: {},
    googleTagManagerProductList: 'unfiltered',
    searchText: '',
    hasSuggestions: false,
    renderPageNumber: 1,
    createdProductCardsAmount: 0,
    faceWeightStart: null,
    faceWeightEnd: null,
    productCount: 0,
    inStockValue: null,
    MergeableDyeLot: false,
  },

  getState(prop) {
    return this.state[prop] !== undefined ? this.state[prop] : this.state;
  },

  setState(newState) {
    this.state = {
      ...this.state,
      ...newState,
    };
    return this.state;
  },

  resetRenderIndex() {
    Page.setState({
      renderPageNumber: 1,
    });
  },

  incrementRenderIndex() {
    Page.setState({
      renderPageNumber: Page.state.renderPageNumber++,
    });
  },

  generateFiltersDataStructure() {
    const filtersElements = document.querySelectorAll('.filter-input');
    const filters = {};
    for (let i = 0; i < filtersElements.length; i += 1) {
      const filterElement = filtersElements[i];
      const filterName = filterElement.getAttribute('data-label');
      const filterType = filterElement.getAttribute('data-filter-type');
      const inputType = filterElement.getAttribute('data-type');
      const filterValue = filterElement.getAttribute('data-value');

      const newFilter = new Filter({
        filterName,
        filterType,
        filterElement,
        inputType,
        filterValue,
      });

      filters[filterType] = filters[filterType] || {};
      filters[filterType][filterValue] = newFilter;
    }

    this.setState({
      filters,
    });
  },

  setStateFromUrl(shouldRender) {
    Page.clearAllFilters(false);
    // fetch the query strings
    const queryStrings = query.getQueryStrings();
    const {
      filters,
    } = Page.state;

    // map query strings to page state
    const searchText = queryStrings[QUERY_SEARCH_BAR_KEY]?.[0] || queryStrings[QUERY_SEARCH_BAR_KEY_ALT]?.[0];
    const sortType = queryStrings[QUERY_SORT_KEY] && queryStrings[QUERY_SORT_KEY][0];

    Page.setState({
      faceWeightStart: queryStrings[FACE_WEIGHT_START] ? queryStrings[FACE_WEIGHT_START][0] : null,
      faceWeightEnd: queryStrings[FACE_WEIGHT_END] ? queryStrings[FACE_WEIGHT_END][0] : null,
      inStockValue: queryStrings[IN_STOCK] ? queryStrings[IN_STOCK][0] : null,
      MergeableDyeLot: queryStrings[MDL] ? true : null,
    });

    faceWeightSlider.createSlider();

    Object.keys(queryStrings).forEach((type) => {
      if (filters[type]) {
        queryStrings[type].forEach((value) => {
          if (type === IN_STOCK) {
            Page.addFilter(type, '');
            Page.inStockFilter.toggleFieldAccess(false);
            return;
          }
          Page.addFilter(type, value);
        });
      }
    });

    if (searchText) {
      searchBar.value = searchText;
    } else {
      Page.searchBar.resetSearchBar();
    }

    if (sortType) {
      $(sortDropdownElement).selectpicker('val', sortType);
    } else {
      $(sortDropdownElement).selectpicker('val', DEFAULT_SORT_TYPE);
    }

    if (searchText || sortType || Page.hasActiveFilters() || shouldRender) {
      Page.setState({
        searchText,
      });
      Page.resetRenderIndex();
      Page.renderProducts(false, true);
    }
  },

  setQueryStrings() {
    const {
      activeFilters, searchText, faceWeightStart, faceWeightEnd, inStockValue, MergeableDyeLot,
    } = Page.state;
    const sortType = $(sortDropdownElement).val();
    const qs = {};

    Object.keys(activeFilters).forEach((type) => {
      Object.values(activeFilters[type]).forEach((filter) => {
        if (qs[type]) {
          qs[type].push(filter.getValue());
        } else {
          qs[type] = [filter.getValue()];
        }
      });
    });

    if (searchText) {
      Object.assign(qs, {
        searchText,
      });
    }

    if (sortType !== DEFAULT_SORT_TYPE) {
      Object.assign(qs, {
        sortby: sortType,
      });
    }

    if (faceWeightStart) {
      Object.assign(qs, { [FACE_WEIGHT_START]: faceWeightStart });
    }

    if (faceWeightEnd) {
      Object.assign(qs, { [FACE_WEIGHT_END]: faceWeightEnd });
    }

    if (inStockValue) {
      Object.assign(qs, { [IN_STOCK]: inStockValue });
    }

    if (MergeableDyeLot) {
      Object.assign(qs, { [MDL]: '' });
    }

    query.setQueryStrings(qs);

    LoginRedirect.changeLoginRedirect();
  },

  setGoogleTagManagerList() {
    const {
      activeFilters,
    } = Page.state;
    const newList = [];
    let googleTagManagerProductList = 'unfiltered';

    Object.values(activeFilters).forEach((type) => {
      Object.values(type).forEach((filter) => {
        newList.push(filter.getState('filterName'));
      });
    });

    if (newList.length) {
      googleTagManagerProductList = newList.join(' | ');
    }

    Page.setState({
      googleTagManagerProductList,
    });
  },

  addFilter(filterType, filterValue) {
    const { filters, activeFilters } = Page.state;
    const filter = filters[filterType][filterValue];
    if (!filter) return undefined;

    filter.createActiveFilterElement();
    filter.selectFilter();

    activeFilters[filterType] = activeFilters[filterType] || {};
    activeFilters[filterType][filterValue] = filter;

    Page.setState({
      activeFilters,
    });

    return activeFilters;
  },

  removeFilter(type, key) {
    const {
      activeFilters,
    } = this.state;
    const filter = activeFilters[type][key];

    filter.removeActiveFilterElement();
    filter.deselectFilter();
    delete activeFilters[type][key];

    if (Object.keys(activeFilters[type]).length === 0) {
      delete activeFilters[type];
    }

    Page.setState({
      activeFilters,
    });
    clearCachedProducts();

    return activeFilters;
  },

  clearAllFilters(shouldRender) {
    const {
      activeFilters,
    } = Page.state;

    Object.values(activeFilters).forEach((type) => {
      Object.values(type).forEach((filter) => {
        filter.removeActiveFilterElement();
        filter.deselectFilter();
        if (filter.state?.filterType === IN_STOCK) {
          Page.inStockFilter.toggleFieldAccess(true);
        }
      });
    });

    Page.setState({
      activeFilters: {},
      MergeableDyeLot: false,
      inStockValue: null,
    });
    Page.setGoogleTagManagerList();

    if (shouldRender) {
      Page.resetRenderIndex();
      clearCachedProducts();
      Page.renderProducts();
    }
  },

  clearSizeAndInStockFilters() {
    const {
      activeFilters,
    } = Page.state;
    const otherFilters = activeFilters;
    Object.values(activeFilters).forEach((type) => {
      Object.values(type).forEach((filter) => {
        if (filter.state?.filterType === DISPLAY_SIZE || filter.state?.filterType === IN_STOCK) {
          filter.removeActiveFilterElement();
          filter.deselectFilter();

          if (filter.state?.filterType === IN_STOCK) {
            Page.inStockFilter.toggleFieldAccess(true);
            Page.inStockFilter.inputField.value = '';
          }

          delete otherFilters[filter.state?.filterType][filter.state?.filterValue];
          if (Object.keys(otherFilters[filter.state?.filterType]).length === 0) {
            delete otherFilters[filter.state?.filterType];
          }
        }
      });
    });

    Page.setState({
      activeFilters: otherFilters,
      MergeableDyeLot: false,
      inStockValue: null,
    });
    Page.setGoogleTagManagerList();
  },

  isFilterAlreadyAdded(type, key) {
    const {
      activeFilters,
    } = this.state;
    return activeFilters[type] && activeFilters[type].hasOwnProperty(key);
  },

  hasActiveFilters() {
    return !!Object.keys(this.state.activeFilters).length;
  },

  onFilterClick(event) {
    const filterElement = event.currentTarget;
    const filterType = filterElement.getAttribute('data-filter-type');
    const filterValue = filterElement.getAttribute('data-value');

    if (Page.isFilterAlreadyAdded(filterType, filterValue)) {
      Page.removeFilter(filterType, filterValue);
    } else {
      Page.addFilter(filterType, filterValue);
    }

    if (filterType === IN_STOCK || filterType === MDL) return;

    Page.setGoogleTagManagerList();
    Page.resetRenderIndex();
    clearCachedProducts();
    Page.renderProducts();
  },

  checkFilters(product) {
    const {
      activeFilters,
    } = Page.state;
    const filterTypes = Object.keys(activeFilters);
    const prodState = product.state;
    let matchCount = 0;

    for (let j = 0; j < filterTypes.length; j++) {
      const type = filterTypes[j];
      const filters = Object.keys(activeFilters[type]);

      for (let i = 0; i < filters.length; i++) {
        const key = filters[i];
        const filter = activeFilters[type][key];
        const valueToCheck = filter.getValue();
        if (type === 'QuickShip') {
          Page.setState({ isColorModeEnabled: true });
          matchCount++;
          break;
        } else if (type === 'Color') {
          Page.setState({ isColorModeEnabled: true });
          matchCount++;
          break;
        } else if (type === 'GSA' && prodState.IsGsaApproved == 'true') {
          matchCount++;
          break;
        } else if (type === 'TuftedWeight') {
          const tuftedWeight = (prodState[type] && prodState[type].Imperial && prodState[type].Imperial.OriginalValue)
            ? prodState[type].Imperial.OriginalValue
            : 0;
          const inRange = faceWeightSlider.isInRange(tuftedWeight);
          if (inRange) {
            faceWeightSlider.setRangeInState();
            matchCount++;
            break;
          }
        } else if (type === 'WareLayerThickness') {
          if (prodState[type]?.Imperial?.FormattedValue === parseInt(valueToCheck)) {
            matchCount++;
            break;
          }
        } else if (valueToCheck === prodState[type]) {
          matchCount++;
          break;
        }
      }
    }

    if (matchCount === filterTypes.length) {
      return true;
    }

    return false;
  },

  observeLastProduct() {
    const target = productsContainer.lastElementChild;
    if (target === null) {
      return;
    }

    const io = new IntersectionObserver(((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting || (window.scrollY > $('#products-container').height())) {
          Page.renderProducts(true);
          observer.disconnect();
        }
      });
    }), {
      threshold: 0.5,
    });

    io.observe(target);
  },
  renderProductsCached() {
    const documentFragment = document.createDocumentFragment();
    const {
      renderPageNumber,
      productCount,
      createdProductCardsAmount,
      scrollY,
    } = JSON.parse(window.sessionStorage.getItem('productSearchPageData'));

    const cachedProducts = JSON.parse(window.sessionStorage.getItem('cachedProducts'));
    const increment = createdProductCardsAmount;
    const products = cachedProducts.map((prod) => new Product(prod));

    $(products).each((index, product) => {
      documentFragment.appendChild(product.createCardElement(increment + index + 1));
    });

    productsContainer.appendChild(documentFragment);

    Page.setState({
      renderPageNumber,
      productCount,
      createdProductCardsAmount,
    });

    Page.observeLastProduct();
    ShawContract.lazyLoadImages();

    _delay(() => {
      window.scrollTo(0, scrollY);
    }, 300);
    window.sessionStorage.removeItem('navigatedBackFromProduct');
  },
  renderProducts(shouldAppend, dontSetQueryStrings) {
    if (!dontSetQueryStrings && !shouldAppend) {
      Page.setQueryStrings();
    }

    if (!shouldAppend) {
      utility.removeChildren(productsContainer);
    }
    const documentFragment = document.createDocumentFragment();
    const { searchText = '' } = Page.state;
    const pageNumber = Page.state.renderPageNumber;
    const InStock = Page.state.inStockValue ? Page.state.inStockValue : 0;
    const { MergeableDyeLot } = Page.state;

    const urlQueryParams = window.location.search.length < 2 ? '' : window.location.search.startsWith('?') ? `&${window.location.search.substring(1)}` : window.location.search;
    let productType = window.location.pathname.split('/').pop().toLowerCase();
    if (productType === 'custompatterns') productType = 'custom%20patterns';
    const url = `${tilesEndpoint}?ProductType=${productType}&PageNumber=${pageNumber}&searchText=${searchText}${Page.inStockFilter.switch && this.inStockFilter.switch?.checked ? `&InStock=${InStock}${MergeableDyeLot ? `&MergeableDyeLot=${MergeableDyeLot}` : ''}` : ''}${urlQueryParams}`;

    if (window.sessionStorage.getItem('navigatedBackFromProduct') === window.location?.href) {
      try {
        this.renderProductsCached();
      } catch (e) {
        clearCachedProducts();
        console.error(e);
      }
    } else {
      $.get(url, (data) => {
        if (data.Products) {
          const products = data.Products.map((prod) => new Product(prod));

          if (productType === 'custom%20patterns') {
            Page.setState({
              cardType: 'Custom Pattern',
            });
          }

          const increment = Page.state.createdProductCardsAmount;

          $(products).each((index, product) => {
            documentFragment.appendChild(product.createCardElement(increment + index + 1));
          });

          const preCachedProducts = window.sessionStorage.getItem('cachedProducts');
          if (preCachedProducts) {
            const parsedPreCached = JSON.parse(preCachedProducts);
            const cachedProducts = parsedPreCached.concat(data.Products);
            window.sessionStorage.setItem('cachedProducts', JSON.stringify(cachedProducts));
          } else {
            window.sessionStorage.setItem('cachedProducts', JSON.stringify(data.Products));
          }

          Page.setState({
            createdProductCardsAmount: Page.state.createdProductCardsAmount + products.length,
          });

          productsContainer.appendChild(documentFragment);

          if (pageNumber < data.Metadata.PageCount) {
            Page.observeLastProduct();
          } else {
            utility.hideElement(loadingSpinner);
          }

          Page.setState({
            renderPageNumber: Page.state.renderPageNumber + 1,
            productCount: data.Metadata.TotalCount,
          });

          Page.searchBar.updatePlaceholder();
          ShawContract.lazyLoadImages();
        }
      });
    }
  },

  inStockFilter: {
    form: document.getElementById('in-stock-form'),
    switch: document.getElementById('inStockSwitch'),
    inputField: document.getElementById('in-stock-field'),
    mergeCheckbox: document.getElementById('in-stock-merge'),
    resetBtn: document.getElementById('reset-in-stock-btn'),
    submitBtn: document.getElementById('submit-in-stock-btn'),

    toggleFieldAccess(isDisabled) {
      this.inputField.disabled = isDisabled;
      this.resetBtn.disabled = isDisabled;
      this.submitBtn.disabled = isDisabled;
      if (this.mergeCheckbox) {
        this.mergeCheckbox.disabled = isDisabled;
      }
    },

    onToggle(e) {
      const inStockValue = Page.inStockFilter.inputField?.value.replaceAll(',', '');

      if (e.currentTarget.checked) {
        Page.inStockFilter.toggleFieldAccess(false);
        if (inStockValue) {
          Page.setState({ inStockValue });
        }
      } else {
        Page.inStockFilter.toggleFieldAccess(true);
        Page.setState({ inStockValue: null });
        if (Page.inStockFilter?.mergeCheckbox?.checked) {
          Page.inStockFilter.mergeCheckbox.checked = false;
          Page.removeFilter(MDL, '');
          Page.setState({ MergeableDyeLot: false });
        }
      }
      const GTMbuttonState = e.currentTarget.checked ? 'on' : 'off';
      GoogleTagManager.inStockSwitch(GTMbuttonState);
      Page.resetRenderIndex();
      clearCachedProducts();
      Page.renderProducts();
      Page.setGoogleTagManagerList();
    },

    isNumberKey(evt) {
      const charCode = (evt.which) ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
        return false;
      }
      return true;
    },

    onCopyCheck(e) {
      const data = e.clipboardData.getData('text');
      if (data.length > 9 || !(/^[0-9,]*$/.test(data))) e.preventDefault();
    },

    onChange(e) {
      this.submitBtn.removeAttribute('hidden');
      this.resetBtn.setAttribute('hidden', true);

      const inputFieldVal = Page.inStockFilter.inputField.value.replaceAll(',', '');

      const chars = inputFieldVal.split('').reverse();
      const withCommas = [];
      for (let i = 1; i <= chars.length; i++) {
        withCommas.push(chars[i - 1]);
        if (i % 3 === 0 && i !== chars.length) {
          withCommas.push(',');
        }
      }
      const val = withCommas.reverse().join('');
      Page.inStockFilter.inputField.value = val;

      Page.setState({ inStockValue: inputFieldVal });
    },

    onMergeDyeChange() {
      if (mdlCheckbox) {
        Page.setState({ MergeableDyeLot: mdlCheckbox.checked });
      }
      Page.resetRenderIndex();
      clearCachedProducts();
      Page.renderProducts();
    },

    onSubmit(e) {
      e.preventDefault();
      Page.resetRenderIndex();
      clearCachedProducts();
      Page.renderProducts();
      this.submitBtn.setAttribute('hidden', true);
      this.resetBtn.removeAttribute('hidden');
      GoogleTagManager.inStockInput(this.inputField?.value);
    },

    onReset(e) {
      e.preventDefault();
      this.inputField.value = null;
      Page.setState({ inStockValue: this.inputField.value });
      Page.resetRenderIndex();
      clearCachedProducts();
      Page.renderProducts();
      this.submitBtn.removeAttribute('hidden');
      this.resetBtn.setAttribute('hidden', true);
    },

    onload() {
      if (!inStockSwitch) return;
      $(inStockSwitch).on('change', Page.inStockFilter.onToggle);
      if (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) Page.inStockFilter.inputField.setAttribute('pattern', '^[0-9,]*$');
      this.resetBtn.setAttribute('hidden', true);
      this.inputField.addEventListener('keypress', this.isNumberKey, false);
      this.inputField.addEventListener('input', this.onChange.bind(this));
      this.inputField.addEventListener('paste', this.onCopyCheck.bind(this));
      if (Page.state.inStockValue) {
        this.inputField.value = Page.state.inStockValue;
      }

      this.resetBtn.disabled = !inStockSwitch.checked;
      this.submitBtn.disabled = !inStockSwitch.checked;
      this.form.addEventListener('submit', this.onSubmit.bind(this));
      this.form.addEventListener('reset', this.onReset.bind(this));
    },
  },

  searchBar: {
    placeholder: i18n.FilterResultsLabel || 'Filter these 000 results by keyword',
    firstHalfOfSearchBarPlacecholder: '',
    secondHalfOfsearchBarPlaceholder: '',

    updatePlaceholder() {
      const filteredProductsCount = Page.state.productCount;
      searchBar.placeholder = this.firstHalfOfSearchBarPlacecholder + filteredProductsCount + this.secondHalfOfsearchBarPlaceholder;
    },
    resetSearchBar() {
      searchBar.value = '';
      Page.searchBar.updatePlaceholder();

      Page.setState({
        searchText: '',
      });
    },

    i18nPlaceholder() {
      let isNumberFound = false;
      const strings = this.placeholder.split(' ');

      for (let i = 0; i < strings.length; i += 1) {
        const s = strings[i];
        const isNumber = parseInt(s, 10);

        if (!isNaN(isNumber)) {
          isNumberFound = true;
          this.firstHalfOfSearchBarPlacecholder += ' ';
        } else if (!isNumberFound) {
          this.firstHalfOfSearchBarPlacecholder += ` ${s}`;
        } else {
          this.secondHalfOfsearchBarPlaceholder += ` ${s}`;
        }
      }
    },

    searchForSuggestions() {
      const searchText = searchBar.value.trim().toLowerCase();
      const limit = 5;
      let count = 0;

      if (!searchText) {
        return undefined;
      }

      const urlQueryParams = window.location.search.length < 2 ? '' : window.location.search.startsWith('?') ? `&${window.location.search.substring(1)}` : window.location.search;
      const productType = window.location.pathname.split('/').pop().toLowerCase();
      const url = `${suggestionEndpoint}?productType=${productType}&resultsize=${limit}&searchtext=${searchText}${urlQueryParams}`;

      $.get(url, (suggestions) => {
        if (suggestions) { console.log(suggestions); }
        if (suggestions && searchBar.value.trim().toLowerCase() === searchText) {
          count = suggestions.length;
          utility.removeChildren(suggestionsContainer);

          $(suggestions).each((index, suggestion) => {
            const string = suggestion.trim().toLowerCase();
            const indexFound = string.indexOf(searchText);
            if (indexFound !== -1) {
              Page.searchBar.createSuggestionElement(suggestion, indexFound, searchText);
            }
          });

          if (count && searchText.length > 0) {
            utility.showElement(suggestionsContainer);
          } else {
            utility.hideElement(suggestionsContainer);
          }

          Page.setState({
            hasSuggestions: count > 0,
          });
        }
      });
    },

    createSuggestionElement(string, searchTextStartIndex, searchText) {
      const searchTextEndIndex = searchTextStartIndex + searchText.length;
      const beforeSearchText = string.slice(0, searchTextStartIndex);
      const matchingSearchText = string.slice(searchTextStartIndex, searchTextEndIndex);
      const afterSearchText = string.slice(searchTextEndIndex);

      const div = createElement({
        classes: 'suggestion-item',
        attributes: {
          tabindex: 0,
        },
      });

      const beforeSearchSpan = createElement({
        element: 'span',
        text: beforeSearchText,
      });

      const searchSpan = createElement({
        element: 'span',
        classes: ['blue-regular'],
        text: matchingSearchText,
      });

      const afterSearchSpan = createElement({
        element: 'span',
        text: afterSearchText,
      });

      div.appendChild(beforeSearchSpan);
      div.appendChild(searchSpan);
      div.appendChild(afterSearchSpan);

      div.addEventListener('click', Page.searchBar.onSuggestionClick);
      div.addEventListener('keydown', (e) => {
        // eslint-disable-next-line no-restricted-globals
        if (event.keyCode === 13 || event.which === 13) {
          Page.searchBar.onSuggestionClick(e);
          utility.hideElement(suggestionsContainer);
        }
      });
      suggestionsContainer.appendChild(div);
    },

    onFocus() {
      if (Page.state.hasSuggestions && searchBar.value.trim().toLowerCase() !== Page.state.searchText) {
        utility.showElement(suggestionsContainer);
      }
    },

    onBlur() {
      setTimeout(() => {
        const {
          activeElement,
        } = document;
        const isActiveElementWithin = activeElement.className.indexOf('suggestion-item') !== -1;
        const isSearchBar = activeElement === searchBar;

        if (!isActiveElementWithin && !isSearchBar) {
          utility.hideElement(suggestionsContainer);
        }
      }, 0);
    },

    onSuggestionClick(e) {
      const newSearchText = e.currentTarget.textContent;
      searchBar.value = newSearchText;
      utility.hideElement(suggestionsContainer);

      if (newSearchText !== Page.state.searchText) {
        Page.setState({
          searchText: newSearchText,
        });
        Page.resetRenderIndex();
        Page.renderProducts();
      }
      clearCachedProducts();
    },

    onTyping() {
      utility.removeChildren(suggestionsContainer);

      Page.searchBar.searchForSuggestions();
    },

    onSubmit(event) {
      event.preventDefault();
      searchBar.blur();
      const searchText = searchBar.value;

      if (searchText !== Page.state.searchText) {
        Page.setState({
          searchText,
        });
        clearCachedProducts();
        Page.resetRenderIndex();
        Page.renderProducts();
      }
      return false;
    },
  },

  mobile: {
    openFilters() {
      utility.preventBodyScroll({
        bgClasses: 'light-blue',
        bodyClasses: 'show-filters',
      });
    },
  },

  onInit() {
    $(mdlCheckbox).on('change', Page.inStockFilter.onMergeDyeChange);
    Page.generateFiltersDataStructure();
    Page.setStateFromUrl(true);
    Page.setGoogleTagManagerList();

    Page.searchBar.i18nPlaceholder();
    Page.searchBar.updatePlaceholder();
    searchBar.addEventListener('focus', Page.searchBar.onFocus);
    searchBar.addEventListener('blur', Page.searchBar.onBlur);
    searchBar.addEventListener('keyup', utility.debounce(Page.searchBar.onTyping, 200));
    searchBarForm.addEventListener('submit', Page.searchBar.onSubmit);
    searchBarForm.addEventListener('search', Page.searchBar.onSubmit);
    searchBarForm.addEventListener('focusout', Page.searchBar.onBlur);
    filtersCollapseBtn.addEventListener('click', utility.filtersCollapse);

    Page.inStockFilter.onload();

    const filterInputs = document.querySelectorAll('.filter-input');
    for (let i = 0; i < filterInputs.length; i += 1) {
      filterInputs[i].addEventListener('click', Page.onFilterClick);
    }

    document.getElementById('clear-filters').addEventListener('click', () => {
      Page.clearAllFilters(true);
    });

    if (sortDropdownElement) {
      sortDropdownElement.addEventListener('change', () => {
        Page.resetRenderIndex();
        clearCachedProducts();
        Page.renderProducts();
      });
    }

    if (measurementSystemSwitch) {
      const measurementSystemButtons = measurementSystemSwitch.getElementsByTagName('button');

      Array.from(measurementSystemButtons).forEach((button) => {
        if (button.value === ShawContract.preferredMeasurementSystem) {
          button.classList.toggle('selected');
        }

        button.addEventListener('click', (e) => {
          $.post(measurementSystemsEndpoint, { measurementSystem: e.target.value }, () => {
            Array.from(measurementSystemButtons).forEach((button) => {
              button.classList.toggle('selected');
            });
            Array.from(document.getElementsByClassName('uom-label')).forEach((label) => {
              label.classList.toggle('inactive');
            });
            Array.from(document.querySelectorAll('.filter-group.size')).forEach((label) => {
              label.classList.toggle('inactive');
            });
            Page.clearSizeAndInStockFilters();

            Page.resetRenderIndex();
            clearCachedProducts();
            Page.renderProducts();
          });
        });
      });
    }

    document.getElementById('mobile-filter-btn').addEventListener('click', Page.mobile.openFilters);

    window.addEventListener('popstate', () => {
      Page.setStateFromUrl(true);
    });

    Page.observeLastProduct();
  },
};

function Filter(props) {
  const defaultProps = {
    filterName: '',
    filterElement: null,
    activeFilterElement: null,
    inputType: null,
    filterType: null,
    filterValue: '',
  };
  this.state = {
    ...defaultProps,
    ...props,
  };
  return this;
}

Filter.prototype.getState = function getState(prop) {
  return this.state[prop] !== undefined ? this.state[prop] : this.state;
};

Filter.prototype.setState = function setState(newState) {
  this.state = {
    ...this.state,
    ...newState,
  };
  return this.state;
};

Filter.prototype.getValue = function getValue() {
  return this.state.filterValue;
};

Filter.prototype.createActiveFilterElement = function createActiveFilterElement() {
  const {
    filterName,
    filterType,
    filterValue,
  } = this.state;

  const onBtnClick = () => {
    Page.removeFilter(filterType, filterValue);
    if (filterType === IN_STOCK) {
      const event = new Event('change');
      inStockSwitch.dispatchEvent(event);
      return;
    }
    if (filterType === MDL) {
      const event = new Event('change');
      mdlCheckbox.dispatchEvent(event);
      return;
    }
    Page.resetRenderIndex();
    clearCachedProducts();
    Page.renderProducts();
  };

  const el = createElement({
    classes: 'active-filter',
    children: [
      createElement({
        element: 'span',
        text: FormatText.capitalizeEveryWord(filterName),
      }),
      createElement({
        element: 'button',
        classes: 'btn text-size-small ml-3',
        eventListeners: {
          click: onBtnClick,
        },
        children: [
          createElement({
            element: 'i',
            classes: 'fas fa-times font-weight-light',
            attributes: {
              'aria-hidden': true,
            },
          }),
        ],
      }),
    ],
  });

  const fragment = document.createDocumentFragment();
  fragment.appendChild(el);
  filtersContainer.appendChild(fragment);

  this.fadeInFilter();
  this.setState({
    activeFilterElement: el,
  });
};

Filter.prototype.fadeInFilter = function fadeInFilter() {
  setTimeout(() => {
    this.state.activeFilterElement.classList.add('animate');
  }, 0);
};

Filter.prototype.removeActiveFilterElement = function removeActiveFilterElement() {
  filtersContainer.removeChild(this.state.activeFilterElement);
};

Filter.prototype.selectFilter = function selectFilter() {
  const state = this.getState();
  const el = state.filterElement;
  const type = state.inputType;

  switch (type) {
    case 'checkbox': {
      el.setAttribute('checked', 'checked');
      el.checked = true;
      break;
    }
    case 'color-checkbox': {
      el.classList.add('active');
      el.setAttribute('aria-pressed', true);
      break;
    }
    case 'quick-ship': {
      el.setAttribute('checked', 'checked');
      el.checked = true;
      break;
    }
    default: {
      // eslint-disable-next-line no-console
      console.trace('unhandled type on element: ', el);
    }
  }
};

Filter.prototype.deselectFilter = function deselectFilter() {
  const state = this.getState();
  const el = state.filterElement;
  const type = state.inputType;

  switch (type) {
    case 'checkbox': {
      el.removeAttribute('checked');
      el.checked = false;
      break;
    }
    case 'color-checkbox': {
      el.classList.remove('active');
      el.setAttribute('aria-pressed', false);
      Page.setState({
        isColorModeEnabled: false,
      });
      break;
    }
    case 'quick-ship': {
      el.removeAttribute('checked');
      el.checked = false;
      Page.setState({
        isColorModeEnabled: false,
      });
      break;
    }
    default: {
      // eslint-disable-next-line no-console
      console.trace('Unhandled type on element: ', el);
      break;
    }
  }
};

function Product(props) {
  const defaultProps = {
    StyleName: '',
    Link: '',
    StyleNumber: '',
    SearchPageImage: '',
    CollectionName: '',
    CollectionLink: '',
    ColorName: null,
    ColorNumber: null,
    ColorIndex: null,
    QuickShipImage: null,
    Sizes: [],
    Inventory: null,
    Size: null,
  };
  this.state = {
    ...defaultProps,
    ...props,
    CollectionName: props.SearchPageCollectionName,
  };
  return this;
}

Product.prototype.getState = function getState(prop) {
  return this.state[prop] !== undefined ? this.state[prop] : this.state;
};

Product.prototype.setState = function setState(newState) {
  this.state = {
    ...this.state,
    ...newState,
  };
  return this.state;
};

Product.prototype.createCardElement = function createCardElement(position) {
  let newElement;

  switch (Page.state.cardType) {
    case 'Custom Pattern':
      newElement = this.createCustomPatternCard();
      break;

    default:
      newElement = this.createProductCard(position);
      break;
  }

  return newElement;
};

Product.prototype.popoverOpen = function popoverOpen() {
  $(this).popover('show');
  this.popoverVisible = true;

  const popoverCloseBtn = $('.popover-close-button');
  const popoverContainer = $('.popover');

  const hidePopover = () => {
    $('.popover').popover('hide');
    this.popoverVisible = false;
    listenersRemover();
  };

  const onOutPopoverClick = (e) => {
    if (popoverContainer.has(e.target).length === 0) {
      hidePopover();
    }
  };

  function listenersRemover() {
    popoverCloseBtn.off('click', hidePopover);
    $(document).off('mouseup', onOutPopoverClick);
  }

  if (this.popoverVisible) {
    popoverCloseBtn.click(hidePopover);
    $(document).mouseup(onOutPopoverClick);

    const gtmEventData = JSON.parse($(this).attr('data-gtm-event'));
    GoogleTagManager.productClick(gtmEventData);
  }
};

Product.prototype.createProductCard = function createProductCard(position) {
  const state = this.getState();
  const productName = state.StyleName;
  const productNumber = state.StyleNumber;
  const imageSrc = state.SearchPageImage;
  const collectionName = state.CollectionName;
  const colorName = state.ColorName;
  const colorNumber = state.ColorNumber;
  const inventory = state.Inventory;
  const size = state.Size;
  const showInStockOption = Page.inStockFilter.switch && Page.inStockFilter.switch.checked && inventory;
  const isMergeable = state.Inventory ? state.Inventory.IsMergeableDyeLot : null;

  const productLink = state.Link;

  const collectionCode = state.CollectionCode;
  const collectionLink = `${collectionEndpoint}/${collectionCode}`;
  const quickShipIcon = state.QuickShip?.ArrowLink;
  const list = Page.state.googleTagManagerProductList;

  const gtmEventData = {
    id: productNumber,
    name: productName,
    category: state.ProductType,
    variant: colorNumber ? `${colorName} ${colorNumber}` : undefined,
    list,
    position,
  };

  return createElement({
    classes: 'card product-card',
    children: [
      createElement({
        classes: 'image-wrapper',
        children: [
          createElement({
            element: 'img',
            classes: 'card-img lazyload',
            attributes: {
              'data-src': imageSrc,
              'data-object-fit': '',
              'data-gtm-event': JSON.stringify(gtmEventData),
            },
          }),
          createElement({
            element: 'a',
            shouldRender: !!productLink,
            classes: 'stretched-link',
            attributes: {
              href: productLink,
            },
            eventListeners: {
              click: () => GoogleTagManager.productClick(gtmEventData),
            },
          }),
        ],
      }),
      createElement({
        classes: 'card-body',
        children: [
          createElement({
            classes: 'd-flex justify-content-between',
            children: [
              createElement({
                element: 'a',
                classes: 'black heading-4 hover-red text-decoration-none transition-color',
                attributes: {
                  href: productLink,
                },
                text: productName,
                eventListeners: {
                  click: () => GoogleTagManager.productClick(gtmEventData),
                },
              }),
              createElement({
                element: 'button',
                classes: 'btn save-board-btn text-size-normal align-self-start py-0',
                attributes: {
                  'data-product-type': state.ProductType,
                  'data-product-number': productNumber,
                  'data-color-number': colorNumber,
                },
                eventListeners: {
                  click: (this.openSaveToBoard).bind(this),
                },
                children: [
                  createElement({
                    element: 'i',
                    classes: 'fal fa-heart',
                    attributes: {
                      'aria-hidden': true,
                    },
                  }),
                ],
              }),
            ],
          }),
          createElement({
            classes: 'text-size-large gray-regular',
            text: productNumber,
            children: [
              createElement({
                element: 'img',
                classes: 'quick-ship-icon ml-4',
                attributes: {
                  src: quickShipIcon,
                },
                shouldRender: !!quickShipIcon,
              }),
            ],
          }),
          createElement({
            classes: 'd-flex justify-content-between text-size-small blue-regular medium',
            children: [
              createElement({
                element: 'a',
                shouldRender: collectionCode !== 'N0' && collectionCode !== 'n0',
                attributes: {
                  href: collectionLink,
                },
                text: collectionName,
              }),
              createElement({
                element: 'span',
                shouldRender: collectionCode === 'N0' || collectionCode === 'n0',
              }),
              createElement({
                shouldRender: showInStockOption,
                classes: '',
                element: 'span',
                children: [
                  createElement({
                    href: '#',
                    element: 'a',
                    classes: 'btn popover-dismiss p-0 m-0',
                    attributes: {
                      tabindex: '0',
                      role: 'button',
                      title: '',
                      'data-trigger': 'click',
                      'data-toggle': 'popover',
                      'data-html': true,
                      'data-gtm-event': JSON.stringify(gtmEventData),
                      'data-content': `
                                                    <p><h3 class="popover-close-button"><i class="fal fa-times"></i></h3></p>
                                                    <p><h2 class="popover-text-header">${productName} ${productNumber}</h2></p>
                                                    <p><h4 class="popover-text-secondary margin-bottom8"><b>${ShawContract.i18n['ProductSearch.ProductItemPopover.Color']}:</b> ${colorName} ${colorNumber}</h4></p>
                                                    <p><h4 class="popover-text-secondary"><b>${ShawContract.i18n['ProductSearch.ProductItemPopover.Size']}:</b> ${size}</h4></p>
                                                    <p><hr class="solid margin-y16"></p>
                                                    <p><h2 class="popover-text-header margin-y16">${ShawContract.i18n['ProductSearch.ProductItemPopover.AvailabilityBreakdown']}</h2></p>
                                                    <p><p class="in-stock-info" style="display:none"><span class="text-regular"><b>${ShawContract.i18n['ProductSearch.ProductItemPopover.InStock']}</b></span> <span class="text-regular">${Math.floor(inventory?.AvailableQty)} ${inventory?.Uom}</span></p></p>
                                                    <p><p class="mergeable-dye-lots${isMergeable ? '' : ' hidden'}"><span class="text-regular"><b>${ShawContract.i18n['ProductSearch.ProductItemPopover.MergeableDyeLots']}</b></span></p>
                                                    <p><hr class="solid margin-y16"></p>
                                                    <p><h2 class="contact-us margin-y16"><a href="tel:${ShawContract.i18n['ProductSearch.ProductItemPopover.ReservePhoneNumber']}">${ShawContract.i18n['ProductSearch.ProductItemPopover.CallToInfo']}: <p class="mt-4"><i class="fal fa-phone-alt mr-3"></i>${ShawContract.i18n['ProductSearch.ProductItemPopover.ReservePhoneNumber']}</p></a><h2/></p>
                                                `,
                    },
                    eventListeners: {
                      click: this.popoverOpen,
                    },
                    children: [
                      createElement({
                        element: 'span',
                        classes: 'delivery-box delivery-box-size',
                      }),
                      createElement({
                        element: 'span',
                        text: `${Math.floor(inventory?.AvailableQty)} ${inventory?.Uom}`,
                      }),
                    ],
                  }),
                ],
              }),
            ],
          }),
          createElement({
            element: 'div',
            classes: '',
            children: [
              createElement({
                shouldRender: colorName && colorNumber,
                classes: 'd-flex justify-content-between text-size-small gray-regular medium mt-2',
                text: `${colorName} ${colorNumber}`,
                children: [
                  createElement({
                    shouldRender: showInStockOption && isMergeable,
                    element: 'span',
                    classes: 'mergeable',
                    text: ShawContract.i18n['ProductSearch.ProductItemPopover.Mergeable'],
                  }),
                ],
              }),
            ],
          }),
        ],
      }),
    ],
  });
};

Product.prototype.createCustomPatternCard = function createCustomPatternCard() {
  const {
    ImageUrl,
    StyleName,
    StyleNumber,
    MachineType,
    PatternType,
    Size,
    CollectionName,
    CollectionUrl,
  } = this.state;

  const properties = [
    [i18n.Size, Size],
    [i18n.MachineType, MachineType],
    [i18n.PatternType, PatternType],
  ];

  const img = createElement({
    classes: 'image-wrapper',
    children: [
      createElement({
        element: 'img',
        classes: 'card-img lazyload',
        eventListeners: {
          click: CustomPatternModal.openModal,
        },
        attributes: {
          'data-src': ImageUrl,
          'data-object-fit': '',
          'data-img': `https://foundry.img.trykcloudstatic.com/designs/${StyleNumber}/install?physWidth=72in&physHeight=50in&pixels=500`,
          'data-product-name': StyleName,
          'data-style-number': StyleNumber,
          'data-size': Size,
          'data-machine-type': MachineType,
          'data-pattern-type': PatternType,
          'data-customize-url': `https://foundry.shawhospitality.com/designs/${StyleNumber}?v=2d`,
          'data-list': Page.state.googleTagManagerProductList,
        },
      }),
    ],
  });

  const header = createElement({
    classes: 'text-size-large black py-3',
    children: [
      createElement({
        element: 'span',
        text: `${StyleName} `,
      }),
      createElement({
        element: 'span',
        text: StyleNumber,
      }),
    ],
  });

  const propsWrapper = createElement({
    classes: 'row no-gutters justify-content-between',
    children: this.createCustomProperties(properties),
  });

  const collectionWrapper = createElement({
    classes: 'text-size-small blue-regular medium',
    children: [
      createElement({
        element: 'a',
        shouldRender: !!CollectionName,
        attributes: {
          href: CollectionUrl,
        },
        text: CollectionName,
      }),
    ],
  });

  return createElement({
    classes: 'product-card',
    children: [img, header, propsWrapper, collectionWrapper],
  });
};

Product.prototype.createCustomProperties = function createCustomProperties(properties) {
  return properties
    .filter((prop) => prop.every((a) => a))
    .map((prop) => createElement({
      classes: 'text-size-small pr-4 gray-regular mb-2',
      children: [
        createElement({
          text: `${prop[0]}: `,
        }),
        createElement({
          classes: 'black',
          text: prop[1],
        }),
      ],
    }));
};

Product.prototype.openSaveToBoard = function openAddToBoard(e) {
  const productNumber = e.currentTarget.getAttribute('data-product-number');
  const productType = e.currentTarget.getAttribute('data-product-type');
  const selectedColor = e.currentTarget.getAttribute('data-color-number');

  AddToMyBoards.openModal(ContentItemTypes.product, productType, productNumber, '', '', selectedColor);
};

const faceWeightSlider = {
  elementRef: document.getElementById('face-weight-slider'),
  checkbox: document.getElementById('face-weight-checkbox'),

  createSlider() {
    if (!this.elementRef) {
      return;
    }

    const startValue1 = Page.getState('faceWeightStart') || parseInt(this.elementRef.getAttribute('data-start-1'), 10);
    const startValue2 = Page.getState('faceWeightEnd') || parseInt(this.elementRef.getAttribute('data-start-2'), 10);
    const min = parseInt(this.elementRef.getAttribute('data-min'), 10);
    const max = parseInt(this.elementRef.getAttribute('data-max'), 10);
    const step = parseInt(this.elementRef.getAttribute('data-step'), 10);

    if (!this.elementRef.noUiSlider) {
      noUiSlider.create(this.elementRef, {
        start: [startValue1, startValue2],
        step,
        range: {
          min: [min],
          max: [max],
        },
        pips: {
          mode: 'positions',
          values: [0, 100],
          density: -1,
        },
        connect: [false, true, false],
        tooltips: [true, true],
        format: {
          to(value) {
            return value.toFixed(0);
          },
          from(value) {
            return Number(value).toFixed(0);
          },
        },
      });
    }

    this.elementRef.noUiSlider.on('change', (faceWeightSlider.onChange).bind(this));
  },

  onChange() {
    if (!this.isCheckboxSelected()) this.checkbox.click();
    this.setRangeInState();
    Page.resetRenderIndex();
    clearCachedProducts();
    Page.renderProducts();
  },

  setRangeInState() {
    const range = this.elementRef.noUiSlider.get();
    Page.setState({
      faceWeightStart: parseInt(range[0], 10),
      faceWeightEnd: parseInt(range[1], 10),
    });
  },

  isInRange(value) {
    const range = this.elementRef.noUiSlider.get();
    const rangeStart = parseInt(range[0], 10);
    const rangeEnd = parseInt(range[1], 10);

    if (value >= rangeStart && value <= rangeEnd) {
      return true;
    }

    return false;
  },

  isCheckboxSelected() {
    return this.checkbox.checked;
  },
};

function setSessionStorageData() {
  const productSearchPageData = {
    pageNumber: Page.state.renderPageNumber,
    scrollY: window.scrollY,
    renderPageNumber: Page.state.renderPageNumber,
    productCount: Page.state.productCount,
    createdProductCardsAmount: Page.state.createdProductCardsAmount,
  };
  window.sessionStorage.setItem('productSearchPageData', JSON.stringify(productSearchPageData));

  // clear navigatedBackFromProduct on page leave
  window.sessionStorage.removeItem('navigatedBackFromProduct');
}

function clearCachedProducts() {
  window.sessionStorage.removeItem('cachedProducts');
}

window.addEventListener('beforeunload', (e) => {
  setSessionStorageData();
  const PRODUCT_URL_IDENTIFIER = '/products/';
  if (!document.activeElement?.href?.includes(PRODUCT_URL_IDENTIFIER)) clearCachedProducts();
});

Page.onInit();
